import script from "./games-grid-empty.vue?vue&type=script&lang=ts&setup=true"
export * from "./games-grid-empty.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__